import { PMProgressBar } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { DashboardCardContext } from "../context";

export function addPercentageOfBudgetSpentCard(ctx: DashboardCardContext) {
  const { view } = ctx;

  const percentageOfBudgetSpentComponent = view.addComponent({
    component: PMProgressBar,
    layoutProps: {
      componentId: "percentageOfBudgetSpentComponent",
      title: "",
      description: "",
      labels: ["budget"],
    },
  });

  percentageOfBudgetSpentComponent.mapLayoutProps(({ language }) => ({
    componentId: "percentageOfBudgetSpentComponent",
    labels: ["budget"],
    title: getLocalizedMessage(language, "budgetK"),
    description: getLocalizedMessage(language, "showsBudgetSpent"),
  }));

  percentageOfBudgetSpentComponent.mapState(({ dashboard, language }) => {
    const percentageOfBudgetSpent =
      dashboard?._calculated?.percentageOfBudgetSpent ?? 0;
    const spentBudget = dashboard?._calculated?.spentBudget ?? 0;
    const approvedBudget = dashboard?._calculated?.approvedBudget ?? 0;
    const formatKEur = (value: number) =>
      (value / 1000).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
      });

    return {
      label: getLocalizedMessage(language, "spent"),
      title: getLocalizedMessage(language, "Budget (k€)"),
      topContent: `${getLocalizedMessage(
        language,
        "approvedBudget"
      )}: ${formatKEur(approvedBudget)}`,
      displayTextOverride: `${formatKEur(spentBudget)} (${Math.round(
        percentageOfBudgetSpent
      )}%)`,
      trackColor: "#E0E0E0",
      barColor: "#38BDF8",
      percent: percentageOfBudgetSpent,
    };
  });

  percentageOfBudgetSpentComponent.mapVisibility(
    ({ settings }) =>
      settings?.configuration?.fieldsDefinition
        ?.filter((field) => field.purpose === "projectBasic")
        .find((field) => field.fieldName === "approvedBudget")?.enabled === true
  );
}
